module.exports = __webpack_public_path__ + "static/media/stopwatch.167f5b7a.svg";